import { gql } from '@apollo/client';

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($newPassword: String!, $code: String!) {
    resetPassword(password: $newPassword, passwordConfirmation: $newPassword, code: $code) {
      jwt
      user {
        id
      }
    }
  }
`;
